import { checkIsMobile } from "./resize-detection";

export function responsiveTable(){
    const isMobile = checkIsMobile();
    if(!isMobile) return

    Array.from(document.querySelectorAll('table')).forEach(table => {
    table.style.borderCollapse = 'collapse';
    table.style.width = '95vw';
    table.setAttribute('width', '95vw')
    })
}
   